import { render, staticRenderFns } from "./ModalAddGivs.vue?vue&type=template&id=34e711d3"
import script from "./ModalAddGivs.vue?vue&type=script&lang=js"
export * from "./ModalAddGivs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports